import connect from 'components/Shared/connect';
import CategoryNavigation from 'views/CategoryPage/categoryNavigation';
import { InfoBlock } from 'components/Shared/InfoBlock';
import { Main } from 'components/Shared/Layout';
import { CategoryPageModel } from 'models/CategoryPageModel';
import { resource as rm } from 'utils';
import Categories, { mapToCategories, Category } from 'components/Categories';
import { CountdownAd } from 'components/CountdownAd';
import { MostPopularProducts } from 'components/MostPopularProducts';
import { Ad } from 'components/Ad';

const NUMBER_OF_CATEGORY_LINKS = 8;

interface MergedProps extends CategoryPageModel {
  categories: Category[];
  description: string;
  showAllCategoriesText: string;
  mostPopularProductsTitle: string;
  productGoto: string;
  header: string;
  longDescription: string;
}

const CategoryPage = ({
  header,
  sliderAds,
  countdownAd,
  categories,
  description,
  usps,
  showAllCategoriesText,
  mostPopularProducts,
  mostPopularProductsTitle,
  productGoto,
  displayName,
  categoryImage,
  leaderBoardAd,
  longDescription
}: MergedProps) => (
  <Main>
    {countdownAd && <CountdownAd {...countdownAd} />}
    <CategoryNavigation
      {...{
        sliderAds,
        header,
        categories,
        description,
        usps,
        displayName,
        categoryImage,
        longDescription
      }}
    />
    {leaderBoardAd && <Ad ad={leaderBoardAd} />}
    <Categories {...{ categories, showAllCategoriesText }} />
    <MostPopularProducts {...{ mostPopularProducts, mostPopularProductsTitle, productGoto }} />
    <InfoBlock {...{ header, longDescription }} />
  </Main>
);

export default connect<MergedProps>(({ currentPage, appShell }) => ({
  displayName: (currentPage as CategoryPageModel).displayName,
  categoryImage: (currentPage as CategoryPageModel).categoryImage,
  header: (currentPage as CategoryPageModel).header,
  longDescription: (currentPage as CategoryPageModel).longDescription,
  sliderAds: (currentPage as CategoryPageModel).sliderAds,
  countdownAd: (currentPage as CategoryPageModel).countdownAd,
  description: (currentPage as CategoryPageModel).shortDescription,
  leaderBoardAd: (currentPage as CategoryPageModel).leaderBoardAd,
  mostPopularProducts: (currentPage as CategoryPageModel).mostPopularProducts,
  categories: mapToCategories(
    NUMBER_OF_CATEGORY_LINKS,
    (currentPage as CategoryPageModel).sectionCategories
  ),
  showAllCategoriesText: rm(appShell, 'navigation_seeallcountcategories'),
  mostPopularProductsTitle: rm(appShell, 'toplist_product_header'),
  productGoto: rm(appShell, 'product_goto')
}))(CategoryPage);
